module.exports = __webpack_public_path__ + "static/google-438ed25e4cf0f980c986878790bf663d.png";